import { Component } from '@angular/core';
import { SpinnerModule } from '@vg-constellation/angular-20/spinner';

@Component({
    selector: 'zci-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    imports: [
        SpinnerModule,
    ],
})
export class LoadingIndicatorComponent { }
